export const ENQUIRY_EVENT = {
	CREATE_TASK: "create-task",
	CREATE_APPOINTMENT: "create-appointment",
	OPEN_PERSON_DETAIL: "open-person-detail",
	OPEN_PROPERTY_DETAIL: "open-property-detail",
	APPOINTMENT_CONFIRMATION: "appointment-confirmation",
	ADD_TO_GROUP_APPOINTMENT: "add-to-group-appointment",
	// Per-appointment quick actions mirroring the agenda popover (FRO-11303);
	// status change and phone display stay local to the Enquiry app.
	PRINT_APPOINTMENT: "print-appointment",
	ADD_APPOINTMENT_COMMENT: "add-appointment-comment",
	CREATE_DEMAND: "create-demand",
	EDIT_APPOINTMENT: "edit-appointment",
	DELETE_APPOINTMENT: "delete-appointment",
	ADD_PERSON_TO_APPOINTMENT: "add-person-to-appointment",
	VIEW_EMAIL: "view-email"
};

// ENQUIRY_EVENT.CREATE_TASK data is optional (FRO-11391): absent (the enquiry
// list's "+") opens the New Enquiry drawer, while { taskId } (the detail view's
// "Follow-up task") opens the full New Task drawer seeded from that task. What
// travels and what is left fresh lives in create-task-handoff.ts.

// ENQUIRY_EVENT.ADD_PERSON_TO_APPOINTMENT data is { appointmentId } â€” the
// clicked (empty) child slot of a group appointment. The dialog loads the
// appointment and resolves its group (title, slot list, "New appointment"
// shortcut context) itself; extra fields are tolerated and ignored.

export const ENQUIRY_RESPONSE = {
	TASK_CREATED: "created-task-successfully",
	APPOINTMENT_CREATED: "created-appointment-successfully",
	APPOINTMENT_UPDATED: "updated-appointment-successfully",
	APPOINTMENT_DELETED: "deleted-appointment-successfully"
};

// Messages the embedded agenda calendar (/agenda-webview) accepts from its host,
// so the host can keep one iframe alive and switch tasks without a full reload.
// The type/shape matches the Enquiry app's postActiveTask implementation.
export const AGENDA_WEBVIEW_EVENT = {
	SET_TASK: "set-active-task"
};

// Sent host â†’ embedded app right after the PostHog recorder captured a full
// snapshot, so the embedded app re-emits its own (see
// utils/posthog-iframe-snapshot-bridge.ts). The Enquiry Centre listens for this
// exact type in omnicasa-enquiry-centre/instrumentation-client.ts â€” keep in sync.
export const POSTHOG_PARENT_FULL_SNAPSHOT_EVENT = "posthog-parent-full-snapshot";

// Must contain "agenda" so TaskNewDrawer.isAgendaModule routes save success to EVENT_BUS.AGENDA.CREATE_NEW_TASK.
export const ENQUIRY_TASK_CONTEXT_PREFIX = "enquiry-agenda-create-task";
export const ENQUIRY_APPOINTMENT_CONTEXT_PREFIX = "enquiry-agenda-create-appointment";
export const ENQUIRY_EDIT_APPOINTMENT_CONTEXT_PREFIX = "enquiry-agenda-edit-appointment";

// Keep-alive contract between the WebApp host and the Enquiry app (see
// docs/enquiry-keep-alive-postmessage-contract.md). Every message carries
// `source` so each side can tell the sender application apart.
export const ENQUIRY_KEEP_ALIVE_PROTOCOL = {
	hostSource: "webapp",
	peerSource: "enquiry",
	visibilityType: "enquiry:visibility",
	queryDirtyType: "enquiry:query-dirty",
	readyType: "enquiry:ready",
	dirtyStateType: "enquiry:dirty-state"
};

export const ENQUIRY_KEEP_ALIVE = {
	// Hidden for this long â†’ ask Enquiry whether it is dirty and release when it is not.
	IDLE_RELEASE_MS: 15 * 60 * 1000,
	// No dirty-state answer within this window counts as dirty (Enquiry may not implement it yet).
	DIRTY_QUERY_TIMEOUT_MS: 2000
};
